
export default {
  props: {
    userType: {
      type: Number,
      default: 1
    },
    basicInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      enterpriseNatureList: []  // 企业性质列表
    };
  },
  created() {
    // 获取字典：企业性质列表
    this.$store.dispatch('getSelectDictList', 'ENTERPRISE_NATURE').then(res => {
      if (res.code === '0') {
        this.enterpriseNatureList = res.data;
      }
    });
  }
};
